import { render } from "./CaStatusIndicator.vue?vue&type=template&id=beb0781a&scoped=true"
import script from "./CaStatusIndicator.vue?vue&type=script&lang=js"
export * from "./CaStatusIndicator.vue?vue&type=script&lang=js"

import "./CaStatusIndicator.vue?vue&type=style&index=0&id=beb0781a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb0781a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip});
